"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pickObj = exports.omitObj = exports.lowerCaseFirst = exports.clipByRegexps = exports.clipByLastIndex = exports.stringTrimUntil = exports.templateIf = exports.ensureType = exports.ensureHasProp = exports.assignDefined = exports.findByFields = exports.ensureArray = exports.oneOf = exports.compact = exports.findCustomArray = void 0;
const rambda_1 = require("rambda");
const lodash_compact_1 = __importDefault(require("lodash.compact"));
const findCustomArray = (array, predicate) => {
    let lastResult;
    const foundElem = array.find((item, index, array) => {
        lastResult = predicate(item, index, array);
        return lastResult;
    });
    if (foundElem)
        return lastResult;
    return undefined;
};
exports.findCustomArray = findCustomArray;
/**
 * @returns Array **without** falsey values (`false`, `0`, `""`, `null`, `undefined`, and `NaN`)
 */
const compact = (array) => (0, lodash_compact_1.default)(array);
exports.compact = compact;
const oneOf = (value, ...values) => values.includes(value);
exports.oneOf = oneOf;
const ensureArray = (arg) => (Array.isArray(arg) ? arg : [arg]);
exports.ensureArray = ensureArray;
/**
 * @param fields `undefined` values will be ignored!
 */
const findByFields = (arr, fields) => {
    const filteredFields = filterObjUndefined(fields);
    return arr.find(item => Object.entries(filteredFields).every(([prop, value]) => item[prop] === value));
};
exports.findByFields = findByFields;
// object
const filterObjUndefined = (obj) => Object.fromEntries(Object.entries(obj).filter(([, value]) => value !== undefined));
function assignDefined(target, properties) {
    Object.assign(target, filterObjUndefined(properties));
}
exports.assignDefined = assignDefined;
const ensureHasProp = (obj, key, initValue) => {
    if (!(key in obj))
        obj[key] = initValue;
    return obj[key];
};
exports.ensureHasProp = ensureHasProp;
// misc
/** @throws if not expected */
const ensureType = (expectedType, name) => {
    const actualType = (0, rambda_1.type)(expectedType);
    if (actualType === expectedType)
        return;
    throw new Error(`Expected type ${expectedType}${(0, exports.templateIf)(name, ` from ${name}`)}. Got ${actualType}`);
};
exports.ensureType = ensureType;
// string
/** String if. Previously named as strIf */
const templateIf = (condition, string) => (condition ? string : '');
exports.templateIf = templateIf;
const stringTrimUntil = (input, char) => {
    const charIndex = input.indexOf(char);
    return charIndex === -1 ? input : input.slice(0, charIndex);
};
exports.stringTrimUntil = stringTrimUntil;
const clipByLastIndex = (input, chars) => {
    for (const char of chars) {
        const index = input.lastIndexOf(char);
        input = /* clip exclusively */ input.slice(index === -1 ? 0 : index + 1);
    }
    return input;
};
exports.clipByLastIndex = clipByLastIndex;
/**
 * @param regexps Must have a least one capture group
 */
const clipByRegexps = (input, regexps) => {
    var _a, _b;
    for (const regexp of regexps)
        input = (_b = (_a = input.match(regexp)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : input;
    return input;
};
exports.clipByRegexps = clipByRegexps;
const lowerCaseFirst = (input) => input[0].toLowerCase() + input.slice(1);
exports.lowerCaseFirst = lowerCaseFirst;
// other
var pickOmit_1 = require("./pickOmit");
Object.defineProperty(exports, "omitObj", { enumerable: true, get: function () { return pickOmit_1.omitObj; } });
Object.defineProperty(exports, "pickObj", { enumerable: true, get: function () { return pickOmit_1.pickObj; } });
__exportStar(require("./stringWithPositions"), exports);
